
(function(){
  const c=document.getElementById('heroCanvas');
  const ctx=c.getContext('2d');
  let W,H,pts=[];
  function resize(){W=c.width=window.innerWidth;H=c.height=window.innerHeight}
  resize();window.addEventListener('resize',resize);
  for(let i=0;i<60;i++)pts.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.3,vy:(Math.random()-.5)*.3,r:Math.random()*1.4+.4,a:Math.random()*.45+.15});
  function draw(){
    ctx.clearRect(0,0,W,H);
    for(let i=0;i<pts.length;i++){for(let j=i+1;j<pts.length;j++){const dx=pts[i].x-pts[j].x,dy=pts[i].y-pts[j].y,d=Math.sqrt(dx*dx+dy*dy);if(d<150){ctx.beginPath();ctx.moveTo(pts[i].x,pts[i].y);ctx.lineTo(pts[j].x,pts[j].y);ctx.strokeStyle=`rgba(232,80,26,${(1-d/150)*.1})`;ctx.lineWidth=.5;ctx.stroke()}}}
    pts.forEach(p=>{p.x+=p.vx;p.y+=p.vy;if(p.x<0||p.x>W)p.vx*=-1;if(p.y<0||p.y>H)p.vy*=-1;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);ctx.fillStyle=`rgba(232,80,26,${p.a})`;ctx.fill()});
    requestAnimationFrame(draw);
  }
  draw();
})();

window.addEventListener('scroll',()=>{document.getElementById('navbar').classList.toggle('scrolled',scrollY>60)});

(function(){
  const el=document.getElementById('miniChart');if(!el)return;
  const vals=[42,65,38,71,55,88,63,79,91,74,85,96];const max=Math.max(...vals);
  vals.forEach(v=>{const b=document.createElement('div');b.className='dash-bar-item';b.style.height=(v/max*100)+'%';el.appendChild(b)});
})();

function countUp(el,target,suffix,dur,dec){
  if(!el)return;const step=target/((dur/16));let cur=0;
  const iv=setInterval(()=>{cur=Math.min(cur+step,target);el.textContent=(dec?cur.toFixed(dec):Math.round(cur))+(suffix||'')+'';if(cur>=target)clearInterval(iv)},16);
}
setTimeout(()=>countUp(document.getElementById('ctr-roas'),4.8,'',1200,1),800);
setTimeout(()=>{
  countUp(document.getElementById('anim-leads'),2847,'',1400,0);
  countUp(document.getElementById('anim-cpl'),38,'',1400,0);
  countUp(document.getElementById('anim-cvr'),6.4,'',1400,1);
  countUp(document.getElementById('anim-spend'),142,'',1400,0);
  setTimeout(()=>{const r=document.getElementById('anim-roas');if(r)r.textContent='4.8x';},1400);
},700);

const rsObs=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.querySelectorAll('.result-number').forEach(el=>{const t=parseFloat(el.dataset.target),s=el.dataset.suffix||'',d=parseInt(el.dataset.dec)||0;countUp(el,t,s,1600,d||null)});rsObs.unobserve(e.target)}})},{threshold:.25});
document.querySelectorAll('.results-strip').forEach(el=>rsObs.observe(el));

const obs=new IntersectionObserver(entries=>{entries.forEach((e,i)=>{if(e.isIntersecting){e.target.style.transitionDelay=(i*.07)+'s';e.target.classList.add('visible');obs.unobserve(e.target)}})},{threshold:.08});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

function fmt(n){return new Intl.NumberFormat('de-DE').format(Math.round(n))}
function calcROI(){
  const spend=parseInt(document.getElementById('sl-spend').value);
  const ch=parseInt(document.getElementById('sl-ch').value);
  const ltv=parseInt(document.getElementById('sl-ltv').value);
  const cvr=parseFloat(document.getElementById('sl-cvr').value);
  const mult=[0,.88,1,1.11,1.2][ch]||1;
  const clicks=Math.round(spend/(ch<=2?1.9:2.5));
  const leads=Math.round(clicks*.032*mult);
  const players=Math.round(leads*(cvr/100)*11);
  const cpa=players>0?spend/players:0;
  const rev=players*ltv;
  const roas=spend>0?rev/spend:0;
  document.getElementById('vl-spend').textContent='€'+fmt(spend);
  document.getElementById('vl-ch').textContent=ch+' channel'+(ch>1?'s':'');
  document.getElementById('vl-ltv').textContent='€'+fmt(ltv);
  document.getElementById('vl-cvr').textContent=cvr.toFixed(1)+'%';
  document.getElementById('r-leads').textContent=fmt(leads);
  document.getElementById('r-players').textContent=fmt(players);
  document.getElementById('r-cpa').textContent=cpa>0?'€'+fmt(cpa):'—';
  document.getElementById('r-rev').textContent='€'+fmt(rev);
  document.getElementById('r-roas').textContent=roas>0?roas.toFixed(1)+'x':'—';
}
['sl-spend','sl-ch','sl-ltv','sl-cvr'].forEach(id=>{const el=document.getElementById(id);if(el)el.addEventListener('input',calcROI)});
calcROI();
